module.exports = __webpack_public_path__ + "img/base-map-img-active.193477c5.png";